import React from 'react'
import styled from 'styled-components'
import { Box, Text, Icon, Loading } from '@maui/elements'
import { translate } from './utils'
import { NavLink as Link } from 'react-router-dom'
import Breadcrumbs from './common/Breadcrumbs'

export const PageBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
`

export const PageHeader = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  line-height: 32px;
  margin: 0 0 16px;
  padding: 0;
  min-height: 46px;
  flex-wrap: nowrap;
  
  > * {
    &:last-child {
      margin-right: 0;
    }
  }
`

export const PageHeaderButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 5px 0;
  width: 100%;
  padding: 1em 0 1em;
  float: right;
  margin-top: ${props => props.marginTop};

  @media only screen and (min-width: 800px) {
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: flex-end;
    border-top: 0;
    padding: 0;
    border-top: none;
  }

  @media only screen and (max-width: 600px) {
    margin-top: 0px;
  }
`

export const PageHeaderIcon = ({ src }) => <Icon name={src} size='lg' verticalAlign="middle" marginRight="spaceGapMedium"/>

export const PageHeaderPills = styled.div`
  flex: 1;
  vertical-align: middle;
  display:box;
  box-pack:center;
  box-align:center;
  margin-left: 8px;
`

export const PageHeaderDescription = styled.div`
  width: 66%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const PageHeaderOS = styled(({ className, values = [] }) => (
  <div className={className}>
    <div>Operating Systems:</div>
    <div>
      {values.map(key => {
        return <Icon
        key={key}
        name={key}
        _last={{ marginRight: 0 }}
         />
      })}
    </div>
  </div>
))`
padding: 0 10px;
margin-left: 2em;
min-height: 3em;
border-left: 2px solid ${props => props.theme.dimTextColor};
display: flex;
font-size: 1em;
div {
  justify-content: center;
  align-self: center;
  padding-right: 10px;
}

@media only screen and (max-width: 600px) {
  width: 100%;
  padding: 8px 0 5px;
  border: 0;
  border-top: 1px solid ${props => props.theme.dimTextColor};
  margin: 5px 0;
}
`

export const PageLoading = styled(({ className }) => (
  <div className={className}>
    <Loading />
  </div>
))`
  font-size: 1.8em;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${Loading} {
    margin-right: 0.5em;
  }
`

export const PageNoData = styled(({ className }) => (
  <div className={className}>
    {translate('dataMessages.noDataAvailable')}
  </div>
))`
  font-size: 1.8em;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Page = ({
  iconButtons,
  children,
  iconComponent,
  icon,
  pills,
  title,
  breadCrumbItems,
  motivation,
  operatingSystems,
  shortName,
  aliases,
  ...props
}) => (
  <div {...props}>
    {
    breadCrumbItems?.length > 0 && <Breadcrumbs chevron={true}>
        <Link to='/actors' style={{ textDecoration: 'none' }} ><Text color='colorActionSecondaryDefault' height='16px' font='12px' fontWeight='700'>{breadCrumbItems[0]}</Text></Link>
        <Text color='colorTextDeemphasis' font='12px' mt="2px" fontWeight='400px'>{breadCrumbItems[1]}</Text>
      </Breadcrumbs>
    }
    <PageHeader>
      {iconComponent} {/* Used by Actor and Location pages */}
      {icon && <PageHeaderIcon src={icon} />}
      <Box>
        <Text
          title={title}
          variant='heading2'
          textOverflow='ellipsis'
          overflow='hidden'
        >{title}</Text>
        <Box display="flex">
          {shortName && <Text color='colorTextDeemphasis' fontWeight='700' fontSize='10px'>{shortName}</Text>}
          {shortName && aliases?.length > 0 && <Text color='colorTextDeemphasis' fontWeight='700' fontSize='10px'>{<>,&nbsp;</>}</Text>}
          {aliases?.length > 0 && <Text color='colorTextDeemphasis' fontWeight='700' fontSize='10px'>{aliases.join(', ')}</Text>}
        </Box>
      </Box>
      {operatingSystems && <PageHeaderOS values={operatingSystems} />}
      {pills && <PageHeaderPills>{pills}</PageHeaderPills>}
      {iconButtons && <PageHeaderButtons marginTop={breadCrumbItems?.length > 0 ? '-70px' : '0px'} >{iconButtons}</PageHeaderButtons>}
    </PageHeader>
    <PageBody>
      {children}
    </PageBody>
  </div>
)

export default styled(Page)`
  display: flex;
  flex-direction: column;
  flex: 1;
`
